import React, { useContext, useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/logo.svg';
import { useTranslation, Trans } from "react-i18next";
import { useStores } from "../../core/stores/rootStore";
import Spinner from 'react-bootstrap/Spinner';
import { observer } from "mobx-react";
import Form from 'react-bootstrap/Form';
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toJS } from "mobx";

const RecoverPassword = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const [validated, setValidated] = useState(false);
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const { usersAdminStore, loginStore } = useStores();
    const { recoverPassword } = usersAdminStore;

    const handleSubmit = (event) => {
        event.preventDefault();

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            setIsLoading(true);
            const formData = Object.fromEntries(new FormData(event.target).entries());

            //fetchMyAPI(formData);
            console.log(formData)
            recoverPassword(formData, () => {
                setIsLoading(false);
                navigate("/change-password")
            });
        }

        setValidated(true);
    }

    return (
        <Form noValidate validated={validated} onSubmit={handleSubmit}>

            <center>
                <h1 className="fw-normal mb-3 pb-3 text-primary">
                    <img src={Logo} width="50px" height="50px" alt="Logo" />
                    CH Finance
                </h1>                
            </center>

            <Form.Group className="my-2">
                <Form.Label>{t('email')}</Form.Label>
                <Form.Control
                    disabled={isLoading}
                    name="email"
                    required
                    type="text"
                />
                <Form.Control.Feedback type="invalid">
                    {t('fieldRequired')}
                </Form.Control.Feedback>
            </Form.Group>
        
            {error && <div className="invalid-feedback" style={{ display: "initial" }}><b>{error}</b></div>}

            <div className="pt-1 mb-2 d-grid">

                <button disabled={isLoading} className="btn btn-secondary btn-lg btn-block" type="submit">
                    {isLoading && <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />}
                    &nbsp;{t('recoverPassword')}</button>
            </div>

        </Form>
    );
};

export default RecoverPassword;
